import { MergeInto } from '../../enums/merge-data/merge-into.enum';
import { MergeWith } from '../../enums/merge-data/merge-with.enum';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a MergeData task.
 * Merges two collections and writes the combined result into contextData or processingData.
 */
export class MergeDataConfig extends DestinationTaskConfigBase {
	/** When true, collection1FieldKey extracts an array from processingData as collection 1; when false, all flow records are collection 1. @default false */
	useExpressionCollection1 = false;
	/** Dot-notation path to collection 1 in processingData. Only used when useExpressionCollection1=true. @default '' */
	collection1FieldKey: string = '';
	/** How collection 2 is sourced. MergeWithAllRecords=0 (all records), MergePerRecord=1 (per-record pairing). @default MergeWith.MergeWithAllRecords */
	mergeWith: MergeWith = MergeWith.MergeWithAllRecords;
	/** When true, collection2FieldKey extracts an array from processingData as collection 2. @default false */
	useExpressionCollection2 = false;
	/** Dot-notation path to collection 2 in processingData. Only used when useExpressionCollection2=true. @default '' */
	collection2FieldKey: string = '';
	/** Where to write the merged result. ContextData=0 (contextData[mergePath]), RecordData=1 (processingData[mergePath]). @default MergeInto.ContextData */
	mergeInto: MergeInto = MergeInto.ContextData;
	/** Key name in the target (contextData or processingData) where the merged result is written. @default 'mergeKey' */
	mergePath: string = 'mergeKey';

	constructor(init?: Partial<MergeDataConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
